import { Link } from "react-router";

import { Button } from "@/components/ui/button";

type ButtonProps = React.ComponentProps<typeof Button>;
type Shared = Omit<ButtonProps, "render" | "nativeButton">;

/**
 * A Button that is actually a link.
 *
 * Base UI's Button assumes it renders a native `<button>`. Rendering it as an
 * `<a>` without `nativeButton={false}` strips the button behaviour and logs a
 * warning in development. Wrapping it once here means no call site has to
 * remember that — which is exactly the kind of detail that gets forgotten.
 *
 * Pass `to` for in-app navigation (react-router `Link`) or `href` for an external
 * destination, which opens in a new tab.
 */
export function ButtonLink(
  props: Shared &
    ({ to: string; href?: never } | { href: string; to?: never }),
) {
  const { to, href, ...rest } = props;

  return (
    <Button
      {...rest}
      nativeButton={false}
      render={
        to !== undefined ? (
          <Link to={to} />
        ) : (
          <a href={href} target="_blank" rel="noreferrer" />
        )
      }
    />
  );
}
